import UserReviews from './UserReviews'

export default UserReviews
